import React from "react";
import Image from "next/image";
import PlayDownloadButtons from "@/src/shared/components/PlayDownloadButtons";
import { AppQrCode } from "@/src/shared/features/app-download";

const DownloadSection: React.FC = () => {
  return (
    <section className="w-full px-4 md:px-10 py-12 bg-white">
      <div className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between gap-10 md:gap-20">
        {/* LEFT: Text and Buttons */}
        <div className="text-center md:text-left flex flex-col items-center md:items-start max-w-xl">
          <h2 className="text-2xl md:text-4xl font-bold text-ink-black mb-4">
            Download, Search &<br className="hidden md:block" /> Book Your
            Perfect Place
          </h2>
          <p className="text-ink-secondary text-sm md:text-base mb-6">
            Download the Travela app to explore and manage your journeys
            anytime, anywhere
          </p>

          {/* Download Buttons */}
          <div className="flex items-center justify-center md:justify-start gap-4 mb-6">
            <PlayDownloadButtons />

            {/* Curved Arrow Image - Only visible on desktop */}
            <div className="hidden md:block -ml-4 mt-9 w-[234px] h-[64px]">
              <Image
                src="/download-section-curve.png"
                alt="Curved arrow"
                width={120}
                height={60}
                className="object-contain"
                quality={100}
                unoptimized
              />
            </div>
          </div>

          <div className="flex justify-center w-full lg:w-[392px]">
            <AppQrCode />
          </div>
        </div>

        {/* RIGHT: Phone Images */}
        <div className="relative w-full md:w-[500px] flex justify-center">
          {/* First Phone */}
          <div className="relative w-[200px] h-[400px] md:w-[526px] md:h-[550px] z-20">
            {/* A 1054×1200 webp: the old SVG wrapped a 4096px PNG (8.6 MB, served as is). */}
            <Image
              src="/images/app-mockup.webp"
              alt="The Travela app on two phones"
              fill
              sizes="(max-width: 767px) 200px, 526px"
              style={{ objectFit: "contain" }}
              className="drop-shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
